import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "licencePaper"
const LicencePaperIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 1a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5Zm2 18v-1h10v1H7Zm5-13.6-1.176.718.32-1.34-1.046-.896 1.373-.11L12 2.5l.529 1.272 1.373.11-1.046.896.32 1.34L12 5.4Zm-1.176 10.218L12 14.9l1.176.718-.32-1.34 1.046-.896-1.373-.11L12 12l-.529 1.272-1.373.11 1.046.896-.32 1.34ZM16 7.9l-1.176.718.32-1.34-1.046-.896 1.373-.11L16 5l.529 1.272 1.373.11-1.046.896.32 1.34L16 7.9Zm-9.176.718L8 7.9l1.176.718-.32-1.34 1.046-.896-1.373-.11L8 5l-.529 1.272-1.373.11 1.046.896-.32 1.34ZM16 12.4l-1.176.718.32-1.34-1.046-.896 1.373-.11L16 9.5l.529 1.272 1.373.11-1.046.896.32 1.34L16 12.4Zm-9.176.718L8 12.4l1.176.718-.32-1.34 1.046-.896-1.373-.11L8 9.5l-.529 1.272-1.373.11 1.046.896-.32 1.34Z"
      />
    </svg>
  )
}
export default LicencePaperIcon
